module.exports = __webpack_public_path__ + "static/img/prev-page-disabled.f5abad1d.svg";